import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    user_id: {
        show: true,
        title: i18n.t('message.doctor_0'),
        sortable: false,
        column: 'doctor_id'
    },
    service_id: {
        show: true,
        title: i18n.t('message.service'),
        sortable: false,
        column: 'service_id'
    },
    patient_id: {
        show: true,
        title: i18n.t('message.patient'),
        sortable: false,
        column: 'patient_id'
    },
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};